import Service from "../service";
import AuthService from "../AuthService";

const Auth = {
    login(data) {
        return Service.post("/login", data);
    },
    register(data){
      return Service.post('/register',data);
    },
    getUser() {
        return AuthService.get("/details");
    },
    logout(){
        return AuthService.get("/logout");
    },
    getToken(data) {
        return Service.post("/get-token", data);
    },
    createFingerPrint(data) {
        return Service.post("/create-fingerprint-log", data);
    },
};

export default Auth;
